import { render, staticRenderFns } from "./unicomDeal1.vue?vue&type=template&id=6c6c8d6c&scoped=true"
import script from "./unicomDeal1.vue?vue&type=script&lang=js"
export * from "./unicomDeal1.vue?vue&type=script&lang=js"
import style0 from "./unicomDeal1.vue?vue&type=style&index=0&id=6c6c8d6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c6c8d6c",
  null
  
)

export default component.exports